import { get } from 'lodash';
import { retrieveDataMapper, retrieveObjectMapper } from 'utils';

export const transformApplicableEnquiryDiscounts = (
  resp,
  discountGroups,
  centres,
  isEcda = false
) => {
  const key = isEcda
    ? 'findAllApplicableEcdaRegistrationChildDiscounts'
    : 'findAllApplicableRegistrationChildDiscounts';
  return {
    data: {
      [key]: {
        data: (get(resp, 'data.data', []) || [])?.map(discount => ({
          ...retrieveObjectMapper(discount, [
            'ID:id',
            'name',
            'fk_discount_item_group',
            'discountItemType:discount_item_type_string',
            'type:type_string',
            'amount',
            'start_date',
            'ceased_date',
            'applicationLevel:application_level_string',
            'is_recurrent',
            'active',
          ]),
          discountItemGroup: retrieveDataMapper(
            discountGroups,
            discount?.fk_discount_item_group,
            [
              'name',
              'code',
              'taxable',
              'apply_to',
              'effective_date',
              'acc_pac_code',
            ]
          ),
          centre: retrieveDataMapper(
            get(centres, 'data', []),
            discount?.fk_centre,
            ['ID:id', 'label']
          ),
        })),
        totalCount: get(resp, 'data.totalCount', 0),
      },
    },
    success: true,
  };
};

export default {
  transformApplicableEnquiryDiscounts,
};
